/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The date range a dashboard opens on: a relative window, or an absolute range with the label the date picker gave it.
 */
export type DashboardRange = {
  /**
   * Start of an absolute range
   */
  from?: Date | undefined;
  /**
   * How the date picker named the absolute range
   */
  label?: string | undefined;
  /**
   * A relative window, one a widget may be saved with
   */
  preset?: string | undefined;
  /**
   * End of an absolute range
   */
  to?: Date | undefined;
};

/** @internal */
export const DashboardRange$inboundSchema: z.ZodMiniType<
  DashboardRange,
  unknown
> = z.object({
  from: z.optional(
    z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
  ),
  label: z.optional(z.string()),
  preset: z.optional(z.string()),
  to: z.optional(
    z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
  ),
});
/** @internal */
export type DashboardRange$Outbound = {
  from?: string | undefined;
  label?: string | undefined;
  preset?: string | undefined;
  to?: string | undefined;
};

/** @internal */
export const DashboardRange$outboundSchema: z.ZodMiniType<
  DashboardRange$Outbound,
  DashboardRange
> = z.object({
  from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
  label: z.optional(z.string()),
  preset: z.optional(z.string()),
  to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
});

export function dashboardRangeToJSON(dashboardRange: DashboardRange): string {
  return JSON.stringify(DashboardRange$outboundSchema.parse(dashboardRange));
}
export function dashboardRangeFromJSON(
  jsonString: string,
): SafeParseResult<DashboardRange, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DashboardRange$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DashboardRange' from JSON`,
  );
}
